import DeliveryInfoPanel from "./deliveryInfoPanel.container";

export default DeliveryInfoPanel;
